


import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import {  serviceCallLogin } from "../serviceCall"
import compileErrors from "../compileErorrs"
import { setLoading } from "../../feature/authSlice"

export const loginApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        dispatch(setLoading(true))
        serviceCallLogin({
            url: apiConstants.Invoices.LOGIN,
            method: 'post',
            data: data,
        })
            .then((response) => {
                dispatch(setLoading(false))
                callback && callback(response)
            })
            .catch((error) => {
                dispatch(setLoading(false))
                toast.error(compileErrors(error.response.data.error))
                errorCallBack && errorCallBack(error.response)
            })
    }
}
